import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfiguracionLocal } from '../models/generic/ConfiguracionLocal';
import { Observable } from 'rxjs';
import { Constantes } from '../models/modules/Constantes';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionInicialService {

  ConfigLocal: ConfiguracionLocal;
  public CargoConfiguracion: EventEmitter<ConfiguracionLocal> = new EventEmitter<ConfiguracionLocal>();

  constructor(private httpClient: HttpClient) { 
    this.CargarConfiguracion();
  }

  CargarConfiguracion() {
    if (this.ConfigLocal === null || this.ConfigLocal === undefined) {
      this.ObtenerConfiguracion(Constantes.CONFIGURACION_INICIAL()).subscribe((config: ConfiguracionLocal) => {
        this.ConfigLocal = config;
        this.CargoConfiguracion.emit(this.ConfigLocal);
      });
    } else {
      this.CargoConfiguracion.emit(this.ConfigLocal);
    }
  }
  
  ObtenerConfiguracion(rutaCarga: string): Observable<any> {
    return this.httpClient.get(rutaCarga);
  }
}
